import { SpeakerSimpleSlash } from '@phosphor-icons/react';

export default SpeakerSimpleSlash;
